import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Contact() {
  const [showHireOptions, setShowHireOptions] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await emailjs.sendForm(
        'service_19akvu7', // Your EmailJS Service ID
        'template_6wvc0pr', // Your Template ID
        e.target,
        '1_1x0sigeWr3ZS42B' // Your Public Key
      );

      toast.success('✅ Message sent successfully!', {
        position: 'top-right',
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          background: '#0a0f29',
          color: '#ff6600',
          border: '1px solid #ff6600',
          fontWeight: '500',
        },
      });

      e.target.reset();
    } catch (error) {
      console.error('FAILED...', error.text);
      toast.error('❌ Failed to send message. Please try again.', {
        position: 'top-right',
        autoClose: 4000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          background: '#0a0f29',
          color: '#ff6600',
          border: '1px solid #ff6600',
          fontWeight: '500',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="section">
      <div
        className="container"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 40,
          alignItems: 'start',
        }}
      >
        {/* Contact Form Section */}
        <div style={{ width: '100%' }}>
          <h2>Contact</h2>
          <form
            onSubmit={sendEmail}
            style={{
              display: 'grid',
              gap: 12,
              maxWidth: 560,
              width: '100%',
              margin: '0 auto',
            }}
          >
            <input
              name="name"
              placeholder="Your name"
              required
              style={{
                padding: 12,
                borderRadius: 8,
                border: '1px solid #eef2f5',
              }}
            />
            <input
              name="email"
              type="email"
              placeholder="Your email"
              required
              style={{
                padding: 12,
                borderRadius: 8,
                border: '1px solid #eef2f5',
              }}
            />
            <textarea
              name="message"
              rows={5}
              placeholder="How can we help?"
              required
              style={{
                padding: 12,
                borderRadius: 8,
                border: '1px solid #eef2f5',
              }}
            ></textarea>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
              <button
                type="submit"
                className="cta"
                disabled={loading}
                style={{
                  opacity: loading ? 0.7 : 1,
                  cursor: loading ? 'not-allowed' : 'pointer',
                  width: '100%',
                }}
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </form>
        </div>

        {/* Hire Me Section */}
        <div style={{ textAlign: 'center', marginTop: 40 }}>
          <h2>Hire Us</h2>
          <p>Choose your preferred platform to hire our services.</p>
          <button
            onClick={() => setShowHireOptions(true)}
            className="cta"
            style={{
              padding: '12px 24px',
              borderRadius: 8,
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Hire Us
          </button>

          {showHireOptions && (
            <div
              style={{
                marginTop: 20,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 12,
                width: '100%',
                maxWidth: 300,
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <p>Select a platform:</p>
              <a
                href="https://www.fiverr.com/s/yv5oK6z"
                target="_blank"
                rel="noopener noreferrer"
                className="cta"
                style={{
                  background: '#1dbf73',
                  padding: '12px 0',
                  borderRadius: 8,
                  textDecoration: 'none',
                  color: '#fff',
                  width: '100%',
                  textAlign: 'center',
                }}
              >
                Fiverr
              </a>
              <a
                href="https://www.upwork.com/freelancers/~0154023289892e974e"
                target="_blank"
                rel="noopener noreferrer"
                className="cta"
                style={{
                  background: '#6fda44',
                  padding: '12px 0',
                  borderRadius: 8,
                  textDecoration: 'none',
                  color: '#fff',
                  width: '100%',
                  textAlign: 'center',
                }}
              >
                Upwork
              </a>
              <button
                onClick={() => setShowHireOptions(false)}
                style={{
                  marginTop: 12,
                  background: 'transparent',
                  border: '1px solid #ccc',
                  padding: '8px 16px',
                  borderRadius: 8,
                  cursor: 'pointer',
                  width: '100%',
                }}
              >
                Close
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
